/**
 * Created by Ning Jiang on 2021-06-09.
 */

import {WinPresentationController} from "../WinPresentationController";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {gsap, TimelineLite} from "gsap";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipBackground} from "../../view/DeadwoodRipBackground";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class ReelSplitController extends WinPresentationController {

    private _splitAnimationDelay:number = 0.1;
    private _symbolDelay:number = 0.5;
    private _animations:TimelineLite[] = [];
    private _pauseTl:TimelineLite | null;
    private _skipped:boolean;

    constructor() {
        super("ReelSplitController", true);
    }

    protected hasWin():boolean {
        return DeadwoodRip.model.parsedGameData.reelSplit.some(v => v);
    }

    protected async createWinAnimation():Promise<void> {
        DeadwoodRip.playScattersWin = true;
        this._skipped = false;
        const promises:Promise<any>[] = [];
        const splitReels:number[] = [];
        const noWin:boolean = DeadwoodRip.model.parsedGameData.singleWin === 0;
        let symbolSplitDelay = 100;
        DeadwoodRip.model.parsedGameData.reelSplit.forEach((split, reelId) => {
            if(split) {
                splitReels.push(reelId);
                const tl = new TimelineLite();
                for(let symId = 0; symId < 4; symId++) {
                    const symbol = DeadwoodRip.reels[reelId].getSymbol(symId);
                    tl.add(symbol.split(0, noWin), noWin ? 0 : (symbol.symbolName === "WRS" ? 0 : this._symbolDelay));
                    symbolSplitDelay = Math.min(symbolSplitDelay, symbol.splitSplashDelay);
                }
                tl.add(() => DeadwoodRip.ways.reelSplit(reelId), noWin ? 0 : this._symbolDelay);
                tl.add(() => ArrayHelper.removeFirstMatchElement(this._animations, tl));
                this._animations.push(tl);
                promises.push(Promise.resolve(tl))
            }
        });
        if(!noWin) {
            const totalTl = new TimelineLite();
            totalTl.add(() => {
                DeadwoodRipBackground.shakeStageOnce(0.4);
            }, this._splitAnimationDelay);
            totalTl.add(() => {
                DeadwoodRipBackground.shakeStageOnce(0.8);
            }, this._symbolDelay + this._splitAnimationDelay);
            // sound
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AXE_APPEAR});
            }, 0);
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AXE_HIT});
            }, this._splitAnimationDelay);
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SYMBOL_SPLIT});
            }, symbolSplitDelay);

            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AXE_APPEAR});
            }, this._symbolDelay);
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AXE_HIT});
            }, this._splitAnimationDelay + this._symbolDelay);
            totalTl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SYMBOL_SPLIT});
            }, symbolSplitDelay + this._symbolDelay);

            promises.push(Promise.resolve(totalTl));
        }
        this.playSplitSound(splitReels);

        await Promise.all(promises);

        if(!this._skipped) {
            this._pauseTl = new TimelineLite();
            this._pauseTl.add(gsap.to(this, {duration : 0.2}));
            this._pauseTl.add(() => this._pauseTl = null);
            await Promise.resolve(this._pauseTl);
        }
    }

    public skip():void {
        this._skipped = true;
        this._animations.forEach(animation => {
            animation.timeScale(2);
        });
        if(this._pauseTl && this._pauseTl.isActive()) {
            this._pauseTl.progress(1);
        }
    }

    private playSplitSound(reels:number[]):void {
        // TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.WRS_SPLIT});
    }
}